<script>
    import { getContext } from 'svelte';
    import { Policy } from "@Store";
    import Question from "@components/Question.svelte";
    import { validateClaims } from "@helpers/validator";
    import { claimsAndInsuranceHistoryQuestions } from "@helpers/questions";
    import { getAnswerText } from "@helpers/validator";

    const CONTEXT = getContext('CONTEXT');

    // Call the function to get the questions object
    $: questionsList = claimsAndInsuranceHistoryQuestions($Policy);

    function handleAnswer(e) {
        CONTEXT.handleAnswer(e);
    }

    $: has_claim = getAnswerText($Policy, questionsList.has_the_applicant_named_insured_suffered_any_claims_or_incidents_that_may_result_in_a_claim_prior_to_the_effective_date_of_this_proposed_policy_which_would_have_given_rise_to_a_claim_arising_from_your_professional_activities_in_the_past_year_question) === 'yes';
    $: show_description_of_claim = has_claim;

    $: valid = validateClaims($Policy);  

    $: has_medical_malpractice_insurance = getAnswerText($Policy, questionsList.do_you_currently_have_active_medical_malpractice_insurance_question) === 'yes';
    $: show_retroactive_date = has_medical_malpractice_insurance;

    $: {
        CONTEXT.routeValidation.update(validation => ({
            ...validation,
            claims: valid
        }));
    }
</script>

<div>
    {#if questionsList.has_the_applicant_named_insured_suffered_any_claims_or_incidents_that_may_result_in_a_claim_prior_to_the_effective_date_of_this_proposed_policy_which_would_have_given_rise_to_a_claim_arising_from_your_professional_activities_in_the_past_year_question}
        <Question question={questionsList.has_the_applicant_named_insured_suffered_any_claims_or_incidents_that_may_result_in_a_claim_prior_to_the_effective_date_of_this_proposed_policy_which_would_have_given_rise_to_a_claim_arising_from_your_professional_activities_in_the_past_year_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
    {/if}
    {#if show_description_of_claim}
        <Question question={questionsList.description_of_claim_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
    {/if}
    {#if questionsList.have_you_ever_been_declined_cancelled_or_non_renewed_by_any_insurer_question}
        <Question question={questionsList.have_you_ever_been_declined_cancelled_or_non_renewed_by_any_insurer_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
    {/if}
    {#if questionsList.please_list_your_previous_insurer_s_question}
        <Question question={questionsList.please_list_your_previous_insurer_s_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
    {/if}   
    {#if questionsList.do_you_currently_have_active_medical_malpractice_insurance_question}
        <Question question={questionsList.do_you_currently_have_active_medical_malpractice_insurance_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
    {/if}
    {#if show_retroactive_date}
        <Question question={questionsList.retroactive_date_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
    {/if}
    {#if questionsList.higher_limits_question}
        <Question question={questionsList.higher_limits_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
    {/if}
    {#if questionsList.additional_details_question}
        <Question question={questionsList.additional_details_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
    {/if}
</div>